import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomerById, CustomerConvertor, CustomerView, CustomerViewAddress, CustomerViewTabs } from 'app/shared/models/customer.models';
import { CustomerApi } from 'app/shared/api/customer.api';

@Component({
  selector: 'customer-view',
  templateUrl: './customer-view.component.html'
})
export class CustomerViewComponent implements OnInit, OnChanges {
  api = new CustomerApi(this.http);
  @Input() customer: CustomerById | null = null;
  @Input() customerId: string;
  @Output() customerIdChange = new EventEmitter<string>();
  @Input() deliveryId: string;
  @Output() deliveryIdChange = new EventEmitter<string>();
  @Input() contactId: string;
  @Output() contactIdChange = new EventEmitter<string>();
  @Input() receiver:string;
  @Output() receiverChange = new EventEmitter<string>();

  view: CustomerView | null = null;
  tab: CustomerViewTabs = 'customer';
  display: CustomerViewAddress | null;
  editing: boolean = false;
  showOptions: boolean = false;
  showExtras: boolean = false;
  extraState: 'search' | 'add' = 'search';
  searchString: string = '';
  extraAddresses = [];

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customerId) {
      if (!!changes.customerId.currentValue && changes.customerId.currentValue != changes.customerId.previousValue) {
        this.getCustomer();
      }
      else if (!changes.customerId.currentValue) { this.customer = null; this.view = null };
    }
    if (changes.deliveryId && changes.deliveryId.currentValue != changes.deliveryId.previousValue) {
      this.switchDelivery(this.deliveryId)
    }
    if (changes.contactId && changes.contactId.currentValue != changes.contactId.previousValue) {
      this.switchContact(this.contactId)
    }
  }

  getCustomer() {
    if (!!this.customerId && !this.customer) {
      this.api.getCustomerById(this.customerId).subscribe({
        next: (data: CustomerById) => this.customer = data,
        error: (err) => console.error("Couldn't load customer", err),
        complete: () => this.mapCustomerByIdToCustomerView()
      })
    }
    else if (!!this.customerId && !!this.customer) this.mapCustomerByIdToCustomerView();
  }

  mapCustomerByIdToCustomerView(): void {
    const customer = this.customer;
    const deliveryId = this.deliveryId || null;
    const contactId = this.contactId || null;
    console.log(customer)
    const deliveryAddress = deliveryId && customer['deliveries'] ? customer['deliveries'].find(a => a.deliveryId === deliveryId) : null;
    const contactAddress = contactId && customer['deliveries'] ? customer['contacts'].find(a => a.id === contactId) : null;
    const customerView: CustomerView = {
      att: customer.att,
      vat: customer.cvr,
      ean: customer.ean,
      number: customer.customerNumber,
      customerId: customer.customerId,
      deliveryId: deliveryId,
      contactId: contactId,
      customer: {
        name: customer.customerName,
        address: customer.customerAddress,
        zip: customer.customerZipCode,
        city: customer.customerCity,
        email: customer.customerMail,
        phone: customer.customerPhone,
        mobile: customer.customerMobile
      },
      invoice: {
        name: customer.invoiceName,
        address: customer.invoiceAddress,
        zip: customer.invoiceZipCode,
        city: customer.invoiceCity,
        email: customer.invoiceEmail,
        phone: customer.invoicePhone,
        mobile: customer.invoiceMobile
      },
      delivery: {
        name: deliveryAddress?.customerName || null,
        address: deliveryAddress?.customerAddress || null,
        zip: deliveryAddress?.customerZipCode || null,
        city: deliveryAddress?.customerCity || null,
        email: deliveryAddress?.customerMail || null,
        phone: deliveryAddress?.customerPhone || null,
        mobile: deliveryAddress?.customerMobile || null,
        ean: deliveryAddress?.ean || null,
        att: deliveryAddress?.att || null
      },
      contact: {
        name: contactAddress?.name || null,
        address: contactAddress?.address || null,
        zip: contactAddress?.zipCode || null,
        city: contactAddress?.city || null,
        email: contactAddress?.email || null,
        phone: contactAddress?.phone || null,
        mobile: contactAddress?.mobile || null,
        ean: contactAddress?.ean || null,
        cvr: contactAddress?.cvr || null,
        att: contactAddress?.att || null
      }
    };

    if (!this.deliveryId) {
      customerView.delivery = null;
      customerView.deliveryId = null;
    }
    if (!this.contactId) {
      customerView.contact = null;
      customerView.contactId = null;
    }

    this.view = customerView;
    this.display = this.view[this.tab];
  }

  switchDelivery(deliveryId: string | null): void {
    this.editing = false;
    const deliveryAddress = deliveryId ? this.customer['deliveries'].find(a => a.id === deliveryId) : null;
    if (deliveryAddress) {
      this.view.deliveryId = deliveryId;
      this.view.delivery = {
        name: deliveryAddress.name,
        address: deliveryAddress.address,
        zip: deliveryAddress.zipCode,
        city: deliveryAddress.city,
        email: deliveryAddress.email,
        phone: deliveryAddress.phone,
        mobile: deliveryAddress.mobile
      };
      this.display = this.view.delivery;
    } else {
      this.view.deliveryId = null;
      this.view.delivery = null;
    }
    this.deliveryIdChange.emit(deliveryId);
  }

  switchContact(contactId: string | null): void {
    this.editing = false;
    const contactAddress = contactId ? this.customer['contacts'].find(a => a.id === contactId) : null;
    if (contactAddress) {
      this.view.contactId = contactId;
      this.view.contact = {
        name: contactAddress.name,
        address: contactAddress.address,
        zip: contactAddress.zipCode,
        city: contactAddress.city,
        email: contactAddress.email,
        phone: contactAddress.phone,
        mobile: contactAddress.mobile
      };
      this.display = this.view.contact;
    } else {
      this.view.contactId = null;
      this.view.contact = null;
    }
    this.contactIdChange.emit(contactId);
  }

  switchTab(tab: CustomerViewTabs): void {
    let display: CustomerViewAddress | null = null;
    this.tab = tab;
    switch (tab) {
      case 'customer':
        display = this.view.customer;
        break;
      case 'invoice':
        display = this.view.invoice;
        break;
      case 'delivery':
        if (!!this.customerId) {
          this.api.getCustomerDeliveryPagination(this.customerId, 0, 200).subscribe({
            next: (data) => this.customer['deliveries'] = data
          })
        }
        console.log(this.customer)
        display = this.view.delivery;
        break;
      case 'contact':
        // load contacts
        console.log(this.customerId);
        if (!!this.customerId) {
          this.api.getCustomerContacts(this.customerId).subscribe({
            next: (data) => this.customer['contacts'] = data
          })

        }
        display = this.view.contact;
        break;
    }

    this.display = display;
  }

  getFirstLetterUppercase(str: string): string {
    const lettersOnly = str.replace(/[^a-zA-Z]/g, '');
    return lettersOnly.charAt(0).toUpperCase();
  }

  saveEdit() {
    switch (this.tab) {
      case 'customer': break
      case 'invoice': break
      case 'delivery': break
      case 'contact': break
    }
  }

  cancelEdit() {
    this.switchTab(this.tab);
    this.editing = false;
  }

  switch() {
    switch (this.tab) {
      case 'customer':
      case 'invoice': {
        this.customerIdChange.emit(null)
        break
      }
      case 'delivery': {
        this.deliveryIdChange.emit(null);
        this.searchString = '';
        this.extraState = 'search';
        this.filterExtra();
        this.display = null;
        setTimeout(() => this.editing = true, 200);
        console.log('remove delivery')
        break
      }
      case 'contact': {
        this.contactIdChange.emit(null);
        this.searchString = '';
        this.extraState = 'search';
        this.filterExtra();
        this.display = null;
        setTimeout(() => this.editing = true, 200);
        break
      }
    }
  }

  filterExtra() {
    let s = this.searchString.toLowerCase();
    switch (this.tab) {
      case 'delivery': {
        if (!!s) this.extraAddresses = this.customer['deliveries'].filter(x => !!x.customerName && x.customerName.toLowerCase().match(s) || !!x.customerAddress && x.customerAddress.toLowerCase().match(s))
        else this.extraAddresses = this.customer['deliveries'];
        break
      }
      case 'contact': {
        if (!!s) this.extraAddresses = this.customer['contacts'].filter(x => !!x.name && x.name.toLowerCase().match(s) || !!x.address && x.address.toLowerCase().match(s))
        else this.extraAddresses = !!this.customer['contacts'] ? this.customer['contacts'] : [];
        break
      }
    }
    console.log(this.extraAddresses)
  }

  resetNew() {
    this.display = {
      name: '',
      address: '',
      zip: '',
      city: '',
      email: '',
      phone: '',
      mobile: '',
      att: '',
      ean: '',
      cvr: ''
    }
    switch (this.tab) {
      case 'customer':
      case 'invoice': {
        console.log('Should not occur')
        break
      }
      case 'delivery': {
        this.deliveryIdChange.emit(null);
        break
      }
      case 'contact': {
        this.contactIdChange.emit(null);
        break
      }
    }
  }

  changeReceiver(recipient){
    this.receiverChange.emit(recipient)
  }

  /**
   * Saving address depends on current tab and if there is an id for the
   */
  save() {
    switch (this.tab) {
      case 'customer': {
        this.view.customer = this.display;
        this.editCustomer();
        // Replace customer info with display and 
        break
      }
      case 'invoice': {
        this.view.invoice = this.display;
        this.editCustomer();
        // Replace invoice info with display.
        break
      }
      case 'delivery': {
        this.view.delivery = this.display;
        this.editing = false;
        if (!!this.deliveryId) {
          let address = CustomerConvertor.viewAddressToEditDelivery(this.display);
          this.api.editDeliveryAddress(this.deliveryId, address).subscribe({
            next: () => {
              CustomerConvertor.updateDeliveryAddress(this.customer, this.deliveryId, address);
            }
          })
        }
        else {
          let address = CustomerConvertor.viewAddressToAddDeliveryAddress(this.display, this.customer.customerId);
          this.api.addDeliveryAddress(address).subscribe({
            next: (deliveryId: string) => {
              CustomerConvertor.addDeliveryToCustomer(this.customer, this.display, deliveryId);
              this.deliveryIdChange.emit(deliveryId);
            }
          })
          // create new delivery address, add it to the customer object in addresses, then emit the new id gotten.
        }
        break
      }
      case 'contact': {
        this.view.contact = this.display;
        this.editing = false;
        if (!!this.contactId) {
          let address = CustomerConvertor.viewAddressToContactAddress(this.display);
          this.api.editContactAddress(this.contactId, address).subscribe({
            next: () => {
              CustomerConvertor.updateContactAddress(this.customer, this.contactId, address);
            }
          })
        }
        else {
          let address = CustomerConvertor.viewAddressToAddContactAddress(this.display, this.customer.customerId);
          this.api.addContactAddress(address).subscribe({
            next: (contactId: string) => {
              CustomerConvertor.addContactToCustomer(this.customer, this.display, contactId);
              this.contactIdChange.emit(contactId)
            }
          })
        }
        break
      }
    }
  }

  editCustomer() {
    this.editing = false;
    let edit = CustomerConvertor.customerViewToEditCustomer(this.view);
    this.api.editCustomer(this.customer.customerId, edit).subscribe({
      next: () => console.log('Customer edited')
    })
  }

}

